import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import RevolverWinTransitions from "./revolver-win-transitions";
import { FadeIn } from "slotworks/graphics/animation/base-animations";
import * as particles from "pixi-particles";
import Layers from "slotworks/graphics/layers/layers";

export default class JackpotTransitions extends RevolverWinTransitions {

    private static WAIT = 390;

    public in(): Contract<void> {
        this.resetEverything();
        return Contract.empty();
    }

    public out(): Contract<void> {
        return Contract.empty();
    }

    protected resetEverything() {        
        Layers.CelebrationForeground.getParticle("coinsFront").emit = false;
        RevolverWinTransitions.background = Layers.CelebrationBackground.getSprite("fullscreen");

        RevolverWinTransitions.winValue = Layers.CelebrationForeground.getBitmapText("value");
        RevolverWinTransitions.winValue.visible = false;
    }

    // private onAmountReached = () => {
    //     this.stopTweens();
    //     this.frontEmitter.emit = true;
    //     this.emphasizeWin();
    // }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/jackpot-transition.ts